import { Link } from 'gatsby';
import type { FC } from 'react';
import type { WorkpieceByIndustriesSection } from '../../../@types/gql/home';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import Card from './card';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const HomeIndustrySection: FC<WorkpieceByIndustriesSection> = ({
  Title,
  Industries,
}) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section
      className="py-14 pb-36"
      style={{
        backgroundColor: '#F1F1F1',
      }}
    >
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-1 gap-10 relative">
          <OpacitySlideIn className="flex" slideFrom={{ x: -100, y: 0 }}>
            <h4 className="text-4xl font-bold max-w-xl leading-tight mt-6 flex-1 whitespace-pre-wrap max-lg:text-2xl max-md:mt-0">
              {Title}
            </h4>
            <Link
              className="py-2 px-3 bottom-0 flex h-11 absolute right-0 space-x-1 font-bold text-base items-center transition-smooth rounded-md w-fit border border-red-600 text-red-600 max-md:relative max-lg:text-sm"
              to="/industries/workpiece-by-industry/"
              type="button"
            >
              VIEW ALL
            </Link>
          </OpacitySlideIn>
        </div>
        <div className="mt-8 industryWrap">
          <Slider {...settings}>
            {Industries?.slice(0, 4).map((industry) => (
              <Card key={industry.id} {...industry} />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default HomeIndustrySection;
